// extracted by mini-css-extract-plugin
export default {"box":"RadioMenu_box__1exPt","btnBox":"RadioMenu_btnBox__0ud7E","btn":"RadioMenu_btn__EVk3j","btnAct":"RadioMenu_btnAct__XwmX9"};